<template>
<v-dialog persistent v-model="getDialog" max-width="400px">
<v-card>
  <v-card-title>
    <h3>Add Device</h3>
    <v-spacer></v-spacer>
    <v-btn @click.prevent="close()" text icon small>
      <v-icon>clear</v-icon>
    </v-btn>
  </v-card-title>
  <v-card-text>
    <v-text-field v-model="name" hide-details="auto" label="Name"  style="max-width:300px"/>
    <v-text-field v-model="udid"  hide-details="auto"  label="Udid"  style="max-width:300px"/>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn @click="saveItem" elevation="4" icon small>
      <v-icon>
        forward
      </v-icon>
    </v-btn >
  </v-card-actions>
</v-card>
</v-dialog>
</template>

<script>
import JJ from '@/assets/gitpage_icon.png';
export default {
    data(){
      return {
        JJ,
        items : [
        ],
        udid:'',
        name:''
      }
    },
    props:{
      dialog:{
        type: Boolean
      }
    },
    watch:{
      items(){
        if(this.items.length > 10){
          this.items.shift()
        }
      }
    },
    computed: {
      getDialog(){
        return this.dialog;
      }
    },
    mounted(){
      if(window.localStorage.getItem('arr'))
        this.items=JSON.parse(window.localStorage.getItem('arr'))
      else
        this.items=[]
    },
    methods:{
      saveItem(){
        let temp={name:this.name,udid:this.udid}
        if(temp.name !== ''&&temp.udid != ''){
          this.add(temp)
          this.saveFile()
          this.gotToDevice(temp.udid)
        }
        else{
          alert('Input something.')
        }
      },
      add(e) {
        this.items.push(e);
      },
      saveFile() {
        const data = JSON.stringify(this.items)
        window.localStorage.setItem('arr', data);
        console.log(JSON.parse(window.localStorage.getItem('arr')))
      },
      gotToDevice(device){
        this.$router.push({path:'',query:{udid:device}})
        this.reloadPage()
      },
      reloadPage(){
        this.$router.go();
      },
      close() {
        this.$emit('closeDialog', false);
      },
      
    }
    
}
</script>

<style>

</style>